import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import api from '../../../utils/api'
import { toast } from 'react-toastify';
import AdminLayout from '../components/AdminLayout';

const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  margin-bottom: 24px;
  color: #6b7280;
  a { color: #00a6c2; text-decoration: none; &:hover { text-decoration: underline; } }
`;

const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #d97706;
  margin: 0 0 24px 0;
`;

const Description = styled.p`
  font-size: 14px;
  color: #374151;
  margin: 0 0 16px 0;
  line-height: 1.6;
`;

const HintText = styled.p`
  font-size: 14px;
  color: #374151;
  margin: 0 0 24px 0;
  strong { font-weight: 600; }
`;

const TriggerButton = styled.button`
  padding: 12px 24px;
  background: #00a6c2;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  &:hover { background: #0094ab; }
  &:disabled { background: #9ca3af; cursor: not-allowed; }
`;

function AdminReleaseNotificationPage() {
  const [triggering, setTriggering] = useState(false);

  const handleTrigger = async () => {
    if (!window.confirm('Are you sure you want to trigger the release notification for all users?')) {
      return;
    }

    setTriggering(true);
    try {
      // BE expects PUT (update action), not POST
      await api.put('/admin2/users/release_notification.json');
      toast.success('Release notification triggered successfully');
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Failed to trigger release notification');
    } finally {
      setTriggering(false);
    }
  };

  return (
    <AdminLayout title="Users" pageTitle="Release Notification">
      <Breadcrumb>
        <Link to="/admin2/users">Users</Link>
        <span>›</span>
        <span>Release notification</span>
      </Breadcrumb>

      <PageTitle>Product release notfication</PageTitle>

      <Description>
        Clicking this link will mark the release notification as unseen for every Contently user. 
        Make sure this is actually what you want to do before clicking the link below.
      </Description>

      <HintText>
        <strong>Hint:</strong> Unless we are about to ship a release you probably don't want to be here.
      </HintText>

      <TriggerButton onClick={handleTrigger} disabled={triggering}>
        {triggering ? 'Triggering...' : 'Trigger release notification'}
      </TriggerButton>
    </AdminLayout>
  );
}

export default AdminReleaseNotificationPage;
